import { Badge, Card, CardBody } from "reactstrap"
import ThemePlaceholder from "components/Common/ThemePlaceholder"
import { formatReadableDate, formatSinceDate } from "utils/formatDate"

const coverStyle = {
  background: "linear-gradient(135deg, #f7f9ff 0%, #eef3ff 52%, #e4ecff 100%)",
  borderBottom: "1px solid rgba(85, 110, 230, 0.12)",
}

const coverTitleStyle = {
  color: "#2f3b63",
}

const coverSubtitleStyle = {
  color: "#6c7aa5",
}

const firstMobile = importer => {
  const mobile = importer?.mobile
  if (Array.isArray(mobile)) return mobile.find(Boolean) || "-"
  return mobile || "-"
}

const detailRows = importer => [
  { label: "Slug", value: importer?.slug || "-" },
  { label: "Email", value: importer?.email || "-" },
  { label: "Website", value: importer?.website || "-" },
  { label: "Mobile", value: firstMobile(importer) },
  { label: "Total Vehicles", value: `${importer?.total_stocks ?? 0} Unit` },
]

export default function ImporterProfileCard({
  importer,
  loading = false,
  action = null,
}) {
  const rows = detailRows(importer)

  return (
    <Card className="border-0 shadow-sm overflow-hidden mb-4">
      <div className="px-4 pt-4 pb-5" style={coverStyle}>
        {loading ? (
          <ThemePlaceholder
            style={{
              width: 140,
              height: 28,
              borderRadius: 8,
              backgroundColor: "rgba(85,110,230,.12)",
            }}
          />
        ) : (
          <div className="d-flex justify-content-between align-items-start gap-3">
            <div>
              <h5 className="mb-1" style={coverTitleStyle}>
                Importer Profile
              </h5>
              <p className="mb-0" style={coverSubtitleStyle}>
                Core identity and import activity overview
              </p>
            </div>
            <div className="d-flex align-items-center gap-2">
              {action}
              {importer?.slug ? (
                <Badge className="badge-soft-primary border-0">
                  {importer.slug}
                </Badge>
              ) : null}
            </div>
          </div>
        )}
      </div>

      <CardBody className="p-4" style={{ marginTop: -42 }}>
        <div className="d-flex align-items-end gap-3 mb-4">
          <div
            className="rounded-4 overflow-hidden border border-3 border-white bg-white shadow-sm flex-shrink-0"
            style={{ width: 104, height: 104 }}
          >
            {loading ? (
              <ThemePlaceholder
                style={{ width: "100%", height: "100%", borderRadius: 0 }}
              />
            ) : importer?.logo ? (
              <img
                src={importer.logo}
                alt={importer?.name || "Importer"}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <div
                className="w-100 h-100 d-flex align-items-center justify-content-center text-primary fw-bold"
                style={{ fontSize: 36, background: "#eef2ff" }}
              >
                {(importer?.name || "I").charAt(0).toUpperCase()}
              </div>
            )}
          </div>

          <div className="min-width-0 flex-grow-1">
            {loading ? (
              <>
                <ThemePlaceholder
                  style={{ width: 220, height: 26, borderRadius: 8 }}
                />
                <ThemePlaceholder
                  className="mt-2"
                  style={{ width: 180, height: 18, borderRadius: 8 }}
                />
              </>
            ) : (
              <>
                <h4 className="mb-1 text-truncate">
                  {importer?.name || "Unnamed Importer"}
                </h4>
                <p className="text-muted mb-0 text-truncate">
                  {importer?.email || "No email provided"}
                </p>
              </>
            )}
          </div>
        </div>

        <div className="specs-list">
          {rows.map(item => (
            <div
              key={item.label}
              className="d-flex justify-content-between py-2 border-bottom gap-3"
            >
              <span className="text-muted">{item.label}:</span>
              {loading ? (
                <ThemePlaceholder
                  style={{ width: 140, height: 18, borderRadius: 4 }}
                />
              ) : (
                <span className="fw-medium text-end">{item.value}</span>
              )}
            </div>
          ))}
        </div>

        {!loading && importer?.created_at ? (
          <div className="pt-3 mt-3 border-top">
            <div className="small text-muted">Member Since</div>
            <div>{formatReadableDate(importer.created_at)}</div>
            <div className="small text-muted fst-italic">
              {formatSinceDate(importer.created_at)}
            </div>
          </div>
        ) : null}
      </CardBody>
    </Card>
  )
}
